import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { SubSubGroupForm } from "@univdiam/ui/customComponents/SubSubGroupList/SubSubGroupForm"
// import api from '@/http/api'
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function SubSubGroupAdd() {
  const [groupData, setGroupData] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
      const fetchGroup = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/sub_groups`)
          if (response.status === 200 && response.data) {
            const group = response.data.data
            // Map fields to your form shape
            const transformed = group.map((group: any) => ({
              sub_group_id: group.sub_group_id,
              name: group.name,
              status: group.status === 1 ? "Enabled" : "Disabled"
            }))
            setGroupData(transformed)
          }
        } catch (err) {
          console.error("Failed to fetch group", err)
          navigate("/sub-sub-group")
        }
      }
    
      fetchGroup()
    }, [])

    const handleAddSubSubGroup = async (data: any) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/sub_sub_groups/add`, data)

            if (response.status === 201 || response.status === 200) {
              alert("SubSubGroup created successfully!")
              navigate("/sub-sub-group")
            }
        } catch (error) {
            console.error("Error creating group:", error)
            alert("Failed to create group.")
        }
    }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Sub Sub Group</h1>
      <SubSubGroupForm onSubmit={handleAddSubSubGroup} groupValues={groupData} />
    </div>
  )
}
